module.exports = __webpack_public_path__ + "img/logo-essi-expert.558b0b65.svg";